interface StateBlockProps {
  type: 'loading' | 'empty' | 'error';
  title?: string;
  description?: string;
  actionText?: string;
  onAction?: () => void;
}

const icons = {
  loading: 'ri-loader-4-line animate-spin',
  empty: 'ri-inbox-archive-line',
  error: 'ri-error-warning-line',
};

export default function StateBlock({
  type,
  title,
  description,
  actionText,
  onAction,
}: StateBlockProps) {
  const defaultTitle =
    type === 'loading' ? '正在加载…' : type === 'empty' ? '暂无相关内容' : '加载失败';
  return (
    <div className="w-full py-16 flex flex-col items-center justify-center text-center">
      <div className="w-14 h-14 rounded-full bg-background-100 text-foreground-400 flex items-center justify-center mb-4">
        <i className={`${icons[type]} text-2xl`}></i>
      </div>
      <p className="text-base font-semibold text-foreground-800">{title || defaultTitle}</p>
      {description && (
        <p className="mt-1.5 text-sm text-foreground-500 max-w-md">{description}</p>
      )}
      {actionText && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 px-5 py-2 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionText}
        </button>
      )}
    </div>
  );
}